import type { CommonEditorTab } from "./reducers";
import { mdiFileDocumentOutline } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { NavbarTabButton } from "../shell/NavbarTabButton";

export function NavbarMetadataTabButton() {
  const { t } = useTranslation();

  return (
    <NavbarTabButton
      tooltip={t("NavbarMetadataTabButton.tooltip")}
      value={"metadata" satisfies CommonEditorTab}
      iconPath={mdiFileDocumentOutline}
    />
  );
}
